import $ from 'jquery';
import slider from 'jquery-ui';
import slick from 'slick-carousel';
import config from '../app-config';

function setSliderTemplatePreview() {
    const templatePreview = $('.esti-template-preview');

    $('.esti-template-preview__for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        dots: false,
        fade: true,
        swipe: false,
        asNavFor: '.esti-template-preview__nav'
    });
    $('.esti-template-preview__nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.esti-template-preview__for',
        infinite: false,
        dots: false,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        edgeFriction: 0,
        responsive: [
            {
                breakpoint: 990,
                settings: {
                    vertical: false,
                    verticalSwiping: false,
                    variableWidth: true,
                    centerMode: true
                }
            }
        ]
    });
    $('.esti-template-preview__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        dots: true,
        fade: false,
        edgeFriction: 0
    });

}

function killSliderTemplatePreview() {

    if ($('.esti-template-preview').length > 0) {
        $('.esti-template-preview__nav').slick('unslick');
        $('.esti-template-preview__for').slick('unslick');
        $('.esti-template-preview__slider').slick('unslick');
    }

}

function initSliderTemplatePreview() {
    if ($('.esti-template-preview').length > 0) setSliderTemplatePreview();
}

export { initSliderTemplatePreview, killSliderTemplatePreview };


// WEBPACK FOOTER //
// ./src/_app/layout/slider-template-preview.js